import React from "react";

import { fixedDigitsAfterDecimal } from "../../../../utils";
import Download from "../../../myTask/Worklog/components/Download";
import SelectDatePicker from "../../../myTask/components/Filters/SelectDatePicker";
import Item from "../../../myTask/Worklog/components/Item";
import ByTaskTab from "../../../myTask/Worklog/components/ByTaskTab";
import OpenCardDetail from "../Kanban/openCardDetail";
import Loader from "../../../../components/Loader";
import { useBoardWorklogState } from "./hooks/useBoardWorklogState";

function BoardWorklogComp() {
  const {
    byTask,
    cardData,
    handleByTaskToggle,
    isLoading,
    totalWorkHours,
    worklogs,
  } = useBoardWorklogState();

  return (
    <>
      {cardData && <OpenCardDetail />}
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-space-between mb-4">
            <div className="d-flex">
              <p className="heading-worklog-tab mr-32">Worklogs</p>
              <div className="d-flex align-items-center">
                <div className="mr-32">
                  <span className="hours-header mt-4">
                    {fixedDigitsAfterDecimal(totalWorkHours)} hours
                  </span>
                </div>
                <Download byTask={byTask} />
              </div>
            </div>

            <div className="ml-3 d-flex align-items-center">
              <label className="switch" style={{ width: "72px" }}>
                <input
                  type="checkbox"
                  value={byTask}
                  checked={byTask}
                  onChange={handleByTaskToggle}
                />
                <div className="slider"></div>
              </label>
              <p className="weight-500 font-size-13 mr-24 ml-1">By Task</p>

              <SelectDatePicker />
            </div>
          </div>

          <div className="worklog-scroll">
            {worklogs.length === 0 ? (
              <p className="loader-center">Worklog Not Found</p>
            ) : byTask ? (
              <ByTaskTab worklogs={worklogs} />
            ) : (
              worklogs?.map((worklog, idx) => (
                <Item worklog={worklog} key={`board-worklog-${idx}`} />
              ))
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default BoardWorklogComp;
